import { render, staticRenderFns } from "./SavedScanModal.vue?vue&type=template&id=6ffa90c6&scoped=true"
import script from "./SavedScanModal.vue?vue&type=script&lang=js"
export * from "./SavedScanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa90c6",
  null
  
)

export default component.exports